import React from "react";
import styled from "styled-components";
import Navigation from "./Navigation";

interface SidebarProps {
  navToggle: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ navToggle }) => {
  return (
    <SidebarStyled className={navToggle ? "nav-toggle" : ""}>
      <Navigation />
    </SidebarStyled>
  );
};

const SidebarStyled = styled.div`
  width: 280px;
  position: fixed;
  height: 100vh;
  background-color: var(--sidebar-dark-color);
  border-right: 1px solid var(--border-color);
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 20;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 10px;
  }

  @media screen and (max-width: 1200px) {
    transform: translateX(-100%);
  }
`;

export default Sidebar;
